import "./bootstrap";

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App";
import router from "./router";
import Vuex from "vuex";
import mainStore from "./store";
import { VueTables, ServerTable, ClientTable, Event } from "vue-tables-2";
import VueToastr from "@deveodk/vue-toastr";
import { Pagination } from "vue-pagination-2";
import VueInputMask from "vue-inputmask";
import "./plugins/bootstrap-vue";
// import FullCalendar from 'vue-full-calendar'
import VueSlider from 'vue-slider-component'
import '../node_modules/moment/moment'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueTour from 'vue-tour'

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use(CKEditor);

require('vue-tour/dist/vue-tour.css')

window.moment = require('moment');
moment.locale('pt-br');

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);


const translation = {
  count: "Mostrando {from} de {to} até {count} de registros",
  filter: "Pesquisar:",
  filterPlaceholder: "Pesquisar",
  limit: "Registros:",
  noResults: "Nenhum registro encontrado",
  page: "Página:",
  filterBy: "Filtrar por {column}",
  // for dropdown pagination filterBy: 'Filter by {column}',
  // Placeholder for search fields when filtering by column loading:'Loading...',
  // First request to server defaultOption:'Select {column}'
  // default option for list filters }
};

const options = {
  requestFunction: function (data) {
    // data.token = this.$store.getters.token
    return axios
      .get(this.url, {
        params: data,
      })
      .catch(
        function (e) {
          this.dispatch("error", e);
          router.push("/login");
        }.bind(this)
      );
  },
  texts: translation,
  pagination: { chunk: 15, dropdown: false, nav: "scroll" },
  perPage: 10,
  perPageValues: [10, 25, 50, 100],
};

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(router);
Vue.use(ServerTable, options, false, "bootstrap4", "footerPagination");
Vue.use(VueToastr);
Vue.use(VueInputMask.default);
Vue.component('VueSlider', VueSlider)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueTour)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAVReyDOd0JcVSHy1CvERGbMXbqA1pkiZA',
    libraries: 'places',
  },
})

export const store = new Vuex.Store(mainStore);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App, VueSlider },
  template: "<App/>",
  created() {
    this.$store.dispatch("initialize");
  },
});

/*
  <link rel="stylesheet" href="src/assets/auxiliary/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="src/assets/css/style.css">
    <link rel="stylesheet" href="src/assets/auxiliary/animate/animate.css">
    <link rel="stylesheet" href="src/assets/auxiliary/fontawesome/css/all.min.css">    
*/

import "../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";
import "./assets/auxiliary/bootstrap/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/auxiliary/animate/animate.css";
import "./assets/auxiliary/chosen/chosen.min.js";
import "./assets/auxiliary/chartjs/Chart.min.js";
import "./assets/auxiliary/chartjs/utils.js";
import "./assets/auxiliary/fontawesome/css/all.min.css";
import "./assets/js/plugins/metisMenu/jquery.metisMenu";
import "./assets/auxiliary/chartjs/utils.js";
import "../node_modules/vue-select/dist/vue-select.css";
import "../node_modules/vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
// import 'fullcalendar/dist/fullcalendar.css'
// import 'fullcalendar/dist/fullcalendar.css'
import 'vue-slider-component/theme/default.css'

import swal from "sweetalert";

var filter = function (text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter("truncate", filter);

Vue.prototype.$http = window.axios;
Vue.prototype.$message = function (title, msg, type) {
  let newMsg = "";
  if (msg instanceof Object) {
    newMsg += "<ul>";
    for (var key in msg) {
      if (msg.hasOwnProperty(key)) {
        newMsg += "<li>";
        newMsg += msg[key];
        newMsg += "</li>";
      }
    }
    newMsg += "</ul>";
  } else newMsg = msg;

  this.$toastr("add", {
    title: title,
    msg: newMsg,
    clickClose: true,
    timeout: 4000,
    position: "toast-top-right",
    type: type,
  });
};

Vue.prototype.$error = function (error) {
  let errors = error.response ? error.response.data : error;

  if (typeof errors === "object") {
    let html = "<ul>";

    $.each(errors, function (key, value) {
      html += "<li>" + value[0] + "</li>";
    });

    html += "</ul>";

    errors = html;
  }

  this.$message(null, errors, "error");
};



// WEBPACK FOOTER //
// ./src/main.js